<p-toast *ngIf="!commonService.isMobileView" position="top-center" key="myToast"></p-toast>
<p-toast *ngIf="!commonService.isMobileView" position="top-right" key="copy-toast"></p-toast>
<p-toast [breakpoints]="{'991px': {width: '80%', right: '0', left: '0'}}" *ngIf="commonService.isMobileView" key="myToast"></p-toast>
<p-toast *ngIf="commonService.isMobileView" key="copy-toast" [breakpoints]="{'991px': {width: '80%', right: '0', left: '0'}}"></p-toast>
<app-loading *ngIf="isLoading" [loaderHeight]="'default'"> </app-loading>
<p-contextMenu [global]="true" [model]="items" (onShow)="onShowContextMenu()" [autoZIndex]="false"
  [style]="{'z-index': 10000}">
</p-contextMenu>
  <router-outlet *ngIf="!isLoading"></router-outlet>

<div class="no-connection" *ngIf=""></div>

<div *ngIf="noInternetConnection" style="text-align: center;"></div>    
<div *ngIf="!noInternetConnection" style="text-align: center;"></div>
<app-chat-modal></app-chat-modal>
<ng-template #logOutModal class="text-center m-4" let-modal>
    <div class="modal-header d-flex justify-content-between">
        <div class="row">
          <div class="ml-2">
            <h5 class="modal-title" id="exampleModalLongTitle"><span class="font-weight-bold text_baseline"> Inactivity Detected</span>
            </h5>
          </div>
        </div>
      </div>
      <div class="modal-body text-center px-5 py-5">
        <h5>You will be logged out in <span class="font-weight-bold ml-1">{{ count }}</span></h5>
      </div>
      <div class="card-footer text-center">
        <button (click)="continueSession();modal.close()" class="btn btn-success w-80">Stay</button>
      </div>
</ng-template>